// Retouche Overlay
class RetoucheOverlay {
   constructor() {
      this.overlay = null;
      this.container = null;

      // Options state
      this.pointsPressionOption1 = false;
      this.pointsPressionOption2 = false;
      this.ourletSize = 0;
      this.personnalisationText = "";

      // Product price (in cents)
      this.productPrice = 0;

      // Initialize settings from Shopify theme settings
      this.settings = this.getRetoucheSettings();

      // Pricing (in cents) - from settings
      this.prices = {
         pointsPression: this.settings.pointsPressionPrice || 500,
         ourlet: this.settings.ourletPrice || 1000,
         personnalisation: this.settings.personnalisationPrice || 3000,
      };

      // Variant IDs for cart items - from settings
      this.variantIds = {
         pointsPression: this.settings.pointsPressionVariantId || null,
         ourlet: this.settings.ourletVariantId || null,
         personnalisation: this.settings.personnalisationVariantId || null,
      };

      this.init();
   }

   // Helper function to get retouche settings from Shopify theme settings
   getRetoucheSettings() {
      const settings = window.retoucheSettings || {};
      return {
         // General text content
         modalTitle: settings.modalTitle || "Personnalisez votre produit",
         modalDescription: settings.modalDescription || "Ajouter des points de pressions, des ourlets et bien plus encore. N'hésitez pas à personnalisez à votre style.",

         // Points Pression settings
         pointsPressionTitle: settings.pointsPressionTitle || "Points pressions",
         pointsPressionPrice: settings.pointsPressionPrice || 500,
         pointsPressionVariantId: settings.pointsPressionVariantId || null,
         pointsPressionOption1Label: settings.pointsPressionOption1Label || "Décolleté",
         pointsPressionOption2Label: settings.pointsPressionOption2Label || "Fente",

         // Ourlet settings
         ourletTitle: settings.ourletTitle || "Ourlet",
         ourletPrice: settings.ourletPrice || 1000,
         ourletVariantId: settings.ourletVariantId || null,
         ourletLabel: settings.ourletLabel || "Précisez la taille",
         ourletPlaceholder: settings.ourletPlaceholder || "Sélectionner une taille",

         // Personnalisation Complète settings
         personnalisationTitle: settings.personnalisationTitle || "Personnalisation complète",
         personnalisationPrice: settings.personnalisationPrice || 3000,
         personnalisationVariantId: settings.personnalisationVariantId || null,
         personnalisationLabel: settings.personnalisationLabel || "Description de votre personnalisation",
         personnalisationPlaceholder: settings.personnalisationPlaceholder || "Votre personnalisation sur mesure",

         // Legal notice
         legalNotice: settings.legalNotice,

         // Translations
         addToCartText: settings.addToCartText || "Ajouter au panier",

         // Colors
         backgroundColor: settings.backgroundColor || "#ffffff",
         textColor: settings.textColor || "#111111",
         textSecondaryColor: settings.textSecondaryColor || "#757575",
         borderColor: settings.borderColor || "#CDCDCD",
      };
   }

   init() {
      // Create overlay HTML if it doesn't exist
      if (!document.getElementById("retouche-overlay")) {
         this.createOverlay();
      }

      // Get references to elements
      this.overlay = document.getElementById("retouche-overlay");
      this.container = document.querySelector(".retouche-container");

      // Bind events
      this.bindEvents();
   }

   createOverlay() {
      const overlay = document.createElement("div");
      overlay.id = "retouche-overlay";
      overlay.className = "retouche-overlay";

      // Get product image from the page with high quality
      let productImage = null;
      const imgElement = document.querySelector(".product-gallery img") || document.querySelector(".product img");

      if (imgElement) {
         // Try to get high-res from data attributes first
         productImage = imgElement.dataset.src || imgElement.dataset.srcOriginal || imgElement.src;

         // Clean up Shopify size parameters to get higher quality
         if (productImage) {
            // Remove width/height/crop parameters
            productImage = productImage
               .replace(/&width=\d+/g, "")
               .replace(/&height=\d+/g, "")
               .replace(/&crop=[^&]*/g, "")
               .replace(/\?width=\d+&?/g, "?")
               .replace(/\?height=\d+&?/g, "?")
               .replace(/\?crop=[^&]*&?/g, "?")
               .replace(/\?&/, "?") // Fix malformed query string
               .replace(/\?$/, ""); // Remove trailing ?

            // Add high quality parameter
            const separator = productImage.includes("?") ? "&" : "?";
            productImage = `${productImage}${separator}width=1000`;
         }
      }

      if (!productImage) {
         productImage = "https://via.placeholder.com/400x600/f8f8f8/666?text=Produit";
      }

      // Get text content from settings
      const modalTitle = this.settings.modalTitle || "Personnalisez votre produit";
      const modalDescription = this.settings.modalDescription || "Ajouter des points de pressions, des ourlets et bien plus encore. N'hésitez pas à personnalisez à votre style.";

      const pointsPressionTitle = this.settings.pointsPressionTitle || "Points pressions";
      const pointsPressionOption1Label = this.settings.pointsPressionOption1Label || "Décolleté";
      const pointsPressionOption2Label = this.settings.pointsPressionOption2Label || "Fente";

      const ourletTitle = this.settings.ourletTitle || "Ourlet";
      const ourletLabel = this.settings.ourletLabel || "Précisez la taille";
      const ourletPlaceholder = this.settings.ourletPlaceholder || "Sélectionner une taille";

      const personnalisationTitle = this.settings.personnalisationTitle || "Personnalisation complète";
      const personnalisationLabel = this.settings.personnalisationLabel || "Description de votre personnalisation";
      const personnalisationPlaceholder = this.settings.personnalisationPlaceholder || "Votre personnalisation sur mesure";

      const legalNotice =
         this.settings.legalNotice || "La personnalisation complète peut rallonger de 3 jours ouvrés le délai d'expédition de votre commande. Un produit personnalisé ne pourra être ni repris ni échangé ! Une question ? Contactez nous";

      const addToCartText = this.settings.addToCartText || "Ajouter au panier";

      // Format prices for display
      const ppPrice = this.formatPrice(this.prices.pointsPression);
      const ourletPrice = this.formatPrice(this.prices.ourlet);
      const persoPrice = this.formatPrice(this.prices.personnalisation);

      overlay.innerHTML = `
      <div class="retouche-container">
        <!-- Main content with 2 columns -->
        <div class="retouche-main-content">
          <!-- Left column - Product image -->
          <div class="retouche-image-column">
            <img src="${productImage}" alt="Produit" class="retouche-product-image">
          </div>

          <!-- Right column - Form -->
          <div class="retouche-form-column">
            <!-- Header -->
            <div class="retouche-main-header">
              <h2 class="retouche-main-title">${modalTitle}</h2>
              <button type="button" class="retouche-main-close" onclick="hideRetoucheOverlay()" aria-label="Fermer">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>

            <!-- Description -->
            <p class="retouche-description">${modalDescription}</p>

            <div class="retouche-content">

            <!-- Points pressions -->
            <div class="retouche-option">
              <div class="retouche-option-header">
                <h3 class="retouche-option-title">${pointsPressionTitle} (+${ppPrice} à +${this.formatPrice(this.prices.pointsPression * 2)})</h3>
              </div>
              <div class="retouche-button-wrapper">
                <button type="button" class="retouche-button-option button button--uppercase" data-option="decollete" id="points-pression-1">
                  ${pointsPressionOption1Label} (+${ppPrice})
                </button>
                <button type="button" class="retouche-button-option button button--uppercase" data-option="fente" id="points-pression-2">
                  ${pointsPressionOption2Label} (+${ppPrice})
                </button>
              </div>
            </div>

            <!-- Ourlet -->
            <div class="retouche-option">
              <div class="retouche-option-header">
                <h3 class="retouche-option-title">${ourletTitle} (+${ourletPrice})</h3>
              </div>
              <div class="retouche-ourlet-wrapper">
                <label class="retouche-label" for="ourlet-size">${ourletLabel}</label>
                <select id="ourlet-size" class="retouche-select">
                  <option value="0">${ourletPlaceholder}</option>
                  <option value="0.5">0,5 cm</option>
                  <option value="1">1 cm</option>
                  <option value="1.5">1,5 cm</option>
                  <option value="2">2 cm</option>
                  <option value="2.5">2,5 cm</option>
                  <option value="3">3 cm</option>
                  <option value="3.5">3,5 cm</option>
                  <option value="4">4 cm</option>
                  <option value="4.5">4,5 cm</option>
                  <option value="5">5 cm</option>
                  <option value="5.5">5,5 cm</option>
                  <option value="6">6 cm</option>
                  <option value="6.5">6,5 cm</option>
                  <option value="7">7 cm</option>
                  <option value="7.5">7,5 cm</option>
                  <option value="8">8 cm</option>
                  <option value="8.5">8,5 cm</option>
                  <option value="9">9 cm</option>
                  <option value="9.5">9,5 cm</option>
                  <option value="10">10 cm</option>
                </select>
              </div>
            </div>

            <!-- Personnalisation complète -->
            <div class="retouche-option">
              <div class="retouche-option-header">
                <h3 class="retouche-option-title">${personnalisationTitle} (+${persoPrice})</h3>
              </div>
              <div class="retouche-perso-wrapper">
                <label class="retouche-label" for="personnalisation-text">${personnalisationLabel}</label>
                <textarea
                  id="personnalisation-text"
                  class="retouche-textarea"
                  placeholder="${personnalisationPlaceholder}"
                  rows="4"
                ></textarea>
              </div>
            </div>

            <!-- Actions -->
            <div class="retouche-actions">
              <div class="retouche-legal-notice">
                ${legalNotice}
              </div>
              <button class="button button--full button--uppercase retouche--button" id="retouche-add-button" disabled onclick="confirmRetouche()">
                ${addToCartText}
              </button>
            </div>

            </div>
          </div>
        </div>
      </div>
    `;

      document.body.appendChild(overlay);
   }

   bindEvents() {
      // Points pression buttons (toggle style)
      const pointsPression1 = document.getElementById("points-pression-1");
      const pointsPression2 = document.getElementById("points-pression-2");

      if (pointsPression1) {
         pointsPression1.addEventListener("click", (e) => {
            this.pointsPressionOption1 = !this.pointsPressionOption1;
            e.target.classList.toggle("active");
            this.updateTotal();
            this.updateAddButton();
         });
      }

      if (pointsPression2) {
         pointsPression2.addEventListener("click", (e) => {
            this.pointsPressionOption2 = !this.pointsPressionOption2;
            e.target.classList.toggle("active");
            this.updateTotal();
            this.updateAddButton();
         });
      }

      // Ourlet select
      const ourletSelect = document.getElementById("ourlet-size");
      if (ourletSelect) {
         ourletSelect.addEventListener("change", (e) => {
            this.ourletSize = parseFloat(e.target.value);
            this.updateTotal();
            this.updateAddButton();
         });
      }

      // Personnalisation textarea
      const persoTextarea = document.getElementById("personnalisation-text");
      if (persoTextarea) {
         persoTextarea.addEventListener("input", (e) => {
            this.personnalisationText = e.target.value.trim();
            this.updateTotal();
            this.updateAddButton();
         });
      }

      // Close overlay when clicking outside container
      this.overlay.addEventListener("click", (e) => {
         if (e.target === this.overlay) {
            this.hide();
         }
      });

      // Escape key to close
      document.addEventListener("keydown", (e) => {
         if (e.key === "Escape" && this.overlay.classList.contains("active")) {
            this.hide();
         }
      });
   }

   updateTotal() {
      let optionsTotal = 0;

      // Si personnalisation complète est renseignée, elle annule les autres options
      if (this.personnalisationText) {
         optionsTotal = this.prices.personnalisation;
      } else {
         // Points pression (5€ each)
         if (this.pointsPressionOption1) optionsTotal += this.prices.pointsPression;
         if (this.pointsPressionOption2) optionsTotal += this.prices.pointsPression;

         // Ourlet (10€)
         if (this.ourletSize > 0) optionsTotal += this.prices.ourlet;
      }

      // Total = prix produit + options
      const total = this.productPrice + optionsTotal;

      // Update button text
      this.updateButtonText(total);
   }

   formatPrice(cents) {
      const price = (cents / 100)
         .toFixed(2)
         .replace(/\.?0+$/, "")
         .replace(".", ",");
      return `${price}€`;
   }

   updateButtonText(totalCents) {
      const addButton = document.getElementById("retouche-add-button");
      if (!addButton) return;

      const addToCartText = this.settings.addToCartText || "Ajouter au panier";
      const formattedPrice = this.formatPrice(totalCents);
      addButton.textContent = `${addToCartText} - ${formattedPrice}`;
   }

   updateAddButton() {
      const addButton = document.getElementById("retouche-add-button");
      if (!addButton) return;

      const hasSelection = this.pointsPressionOption1 || this.pointsPressionOption2 || this.ourletSize > 0 || this.personnalisationText;

      if (hasSelection) {
         addButton.disabled = false;
         addButton.classList.remove("disabled");
      } else {
         addButton.disabled = true;
         addButton.classList.add("disabled");
      }
   }

   getProductPrice() {
      // Try to get price from product form - check multiple possible selectors
      const priceElement =
         document.querySelector(".price__regular .transcy-money") ||
         document.querySelector(".price .transcy-money") ||
         document.querySelector(".price__regular") ||
         document.querySelector(".price-item--regular .price") ||
         document.querySelector(".product__price .price") ||
         document.querySelector("[data-product-price]");

      if (priceElement) {
         // Get text content and parse price
         const priceText = priceElement.textContent.trim();
         // Extract numbers and decimal separator (either , or .)
         // Remove everything except digits, commas and dots
         let cleanPrice = priceText.replace(/[^\d,\.]/g, "");

         // Replace comma with dot for consistent decimal separator
         cleanPrice = cleanPrice.replace(",", ".");

         // Parse to float
         const priceValue = parseFloat(cleanPrice);

         // Convert to cents and round to avoid floating point errors
         return Math.round(priceValue * 100);
      }

      return 0;
   }

   show() {
      if (!this.overlay) {
         this.init();
      }

      // Get current product price
      this.productPrice = this.getProductPrice();

      // Prevent body scroll
      document.body.style.overflow = "hidden";

      // Show overlay with animation
      this.overlay.style.display = "flex";
      requestAnimationFrame(() => {
         this.overlay.classList.add("active");
      });

      // Update initial button text with product price
      this.updateTotal();
   }

   hide() {
      if (!this.overlay) return;

      // Hide overlay with animation
      this.overlay.classList.remove("active");

      setTimeout(() => {
         this.overlay.style.display = "none";
         document.body.style.overflow = ""; // Restore body scroll
      }, 300);
   }

   async confirm() {
      // Check if at least one option is selected
      const hasSelection = this.pointsPressionOption1 || this.pointsPressionOption2 || this.ourletSize > 0 || this.personnalisationText;

      if (!hasSelection) {
         alert("Veuillez sélectionner au moins une option de retouche.");
         return;
      }

      // Add loading state to button
      const addButton = document.getElementById("retouche-add-button");
      if (addButton) {
         addButton.classList.add("loading");
         addButton.disabled = true;
      }

      try {
         // Add to cart with retouche options and wait for completion
         await this.addRetoucheToProduct();

         // Remove loading state on success
         if (addButton) {
            addButton.classList.remove("loading");
            addButton.disabled = false;
         }

         // Hide modal and reset form
         this.hide();
         this.reset();
      } catch (error) {
         // Remove loading state on error
         if (addButton) {
            addButton.classList.remove("loading");
            addButton.disabled = false;
         }
      }
   }

   async addRetoucheToProduct() {
      // Get variant ID from product form
      const productForm = document.querySelector('form[action*="/cart/add"]');
      let variantId = null;

      if (productForm) {
         const variantInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
         variantId = variantInput ? variantInput.value : null;
      }

      if (!variantId) {
         alert("Erreur: Impossible de déterminer la variante du produit.");
         throw new Error("Variant ID not found");
      }

      // Build properties object for main product
      const mainProductProperties = {};

      // Get labels from settings
      const personnalisationTitle = this.settings.personnalisationTitle || "Personnalisation complète";
      const pointsPressionTitle = this.settings.pointsPressionTitle || "Point pression";
      const pointsPressionOption1Label = this.settings.pointsPressionOption1Label || "Décolleté";
      const pointsPressionOption2Label = this.settings.pointsPressionOption2Label || "Fente";
      const ourletTitle = this.settings.ourletTitle || "Ourlet";

      // Si personnalisation complète, elle annule les autres options
      if (this.personnalisationText) {
         mainProductProperties[personnalisationTitle] = "Oui";
      } else {
         // Add Points pression details
         if (this.pointsPressionOption1 || this.pointsPressionOption2) {
            const selectedOptions = [];
            if (this.pointsPressionOption1) selectedOptions.push(pointsPressionOption1Label);
            if (this.pointsPressionOption2) selectedOptions.push(pointsPressionOption2Label);
            mainProductProperties[pointsPressionTitle] = selectedOptions.join(", ");
         }

         // Add Ourlet details
         if (this.ourletSize > 0) {
            mainProductProperties[ourletTitle] = `${this.ourletSize} cm`;
         }
      }

      // Prepare cart items array
      const items = [
         // Main product with retouche summary
         {
            id: parseInt(variantId),
            quantity: 1,
            properties: mainProductProperties,
         },
      ];

      // Si personnalisation complète, elle annule les autres options
      if (this.personnalisationText) {
         items.push({
            id: parseInt(this.variantIds.personnalisation),
            quantity: 1,
            properties: {
               Description: this.personnalisationText,
               _parent_id: variantId,
            },
            parent_id: parseInt(variantId),
         });
      } else {
         // Add Points pression items if selected - one line item per option
         if (this.pointsPressionOption1) {
            items.push({
               id: parseInt(this.variantIds.pointsPression),
               quantity: 1,
               properties: {
                  [pointsPressionTitle]: pointsPressionOption1Label,
                  _parent_id: variantId,
               },
               parent_id: parseInt(variantId),
            });
         }

         if (this.pointsPressionOption2) {
            items.push({
               id: parseInt(this.variantIds.pointsPression),
               quantity: 1,
               properties: {
                  [pointsPressionTitle]: pointsPressionOption2Label,
                  _parent_id: variantId,
               },
               parent_id: parseInt(variantId),
            });
         }

         // Add Ourlet item if selected
         if (this.ourletSize > 0) {
            items.push({
               id: parseInt(this.variantIds.ourlet),
               quantity: 1,
               properties: {
                  [ourletTitle]: `${this.ourletSize} cm`,
                  _parent_id: variantId,
               },
               parent_id: parseInt(variantId),
            });
         }
      }

      const cartData = { items };

      console.log("Adding to cart:", cartData);

      try {
         // Add to cart via Shopify API
         const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify(cartData),
         });

         if (!response.ok) {
            const errorData = await response.json();
            console.error("Cart API error:", errorData);
            console.error("Request was:", cartData);

            // Check if variant IDs are valid
            if (errorData.errors === "Cart Error") {
               throw new Error("Un ou plusieurs produits de retouche sont invalides. Veuillez vérifier les variant IDs.");
            }

            throw new Error(errorData.description || errorData.message || "Erreur lors de l'ajout au panier");
         }

         const data = await response.json();
         console.log("Cart response:", data);

         // Fetch cart sections and render cart drawer
         const cartDrawer = document.querySelector("cart-drawer");
         if (cartDrawer) {
            const sectionsToRender = cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender() : [];
            const sectionsParam = sectionsToRender.map((section) => section.section).join(",");

            const cartResponse = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
            const cartSections = await cartResponse.json();

            cartDrawer.renderContents({ sections: cartSections }, true);
         }

         // Update cart counters and handle note threshold
         if (typeof updateCartCounters === "function") {
            await updateCartCounters();
         }

         return data;
      } catch (error) {
         console.error("Erreur:", error);
         alert("Erreur lors de l'ajout au panier. Veuillez réessayer.");
         throw error; // Re-throw to be caught by confirm()
      }
   }

   reset() {
      // Reset state
      this.pointsPressionOption1 = false;
      this.pointsPressionOption2 = false;
      this.ourletSize = 0;
      this.personnalisationText = "";

      // Reset form elements
      const pointsPression1 = document.getElementById("points-pression-1");
      const pointsPression2 = document.getElementById("points-pression-2");
      const ourletSelect = document.getElementById("ourlet-size");
      const persoTextarea = document.getElementById("personnalisation-text");

      if (pointsPression1) pointsPression1.classList.remove("active");
      if (pointsPression2) pointsPression2.classList.remove("active");
      if (ourletSelect) ourletSelect.value = "0";
      if (persoTextarea) persoTextarea.value = "";

      // Update UI
      this.updateTotal();
      this.updateAddButton();
   }
}

// Initialize retouche overlay
let retoucheOverlayInstance = null;

// Global functions for onclick handlers
function showRetoucheOverlay() {
   if (!retoucheOverlayInstance) {
      retoucheOverlayInstance = new RetoucheOverlay();
   }
   retoucheOverlayInstance.show();
}

function hideRetoucheOverlay() {
   if (retoucheOverlayInstance) {
      retoucheOverlayInstance.hide();
   }
}

function confirmRetouche() {
   if (retoucheOverlayInstance) {
      retoucheOverlayInstance.confirm();
   }
}
